import { motion } from "framer-motion";

const steps = [
  {
    num: "01",
    title: "AI-First Architecture",
    desc: "Every system is designed with AI integration in mind. From intelligent workflows to scalable model integration, we embed machine intelligence directly into core architecture.",
  },
  {
    num: "02",
    title: "Cloud-Native Infrastructure",
    desc: "We build scalable, secure, and performance-driven platforms using modern cloud environments, containerization, and automated deployment pipelines.",
  },
  {
    num: "03",
    title: "Data-Driven Design",
    desc: "Our systems learn and evolve through structured data pipelines, real-time processing, and feedback loops that continuously improve decision-making.",
  },
  {
    num: "04",
    title: "Security by Design",
    desc: "Zero-trust architecture, secure development lifecycle, and compliance-focused engineering ensure resilience, data protection, and enterprise-grade reliability.",
  },
];

const EngineeringSection = () => {
  return (
    <section id="engineering" className="py-24 md:py-32">
      <div className="container px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] text-primary mb-3 font-body">
            Engineering Excellence Meets AI Intelligence
          </p>
          <h2 className="text-3xl md:text-5xl font-bold font-display">
            Our <span className="text-gradient-red">Approach</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="relative p-6 rounded-xl bg-card border border-glass"
            >
              <span className="text-4xl font-display font-bold text-gradient-red opacity-60">
                {s.num}
              </span>
              <h3 className="text-lg font-display font-semibold mt-3 mb-2 text-foreground">
                {s.title}
              </h3>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngineeringSection;